import type { MetaFunction } from 'react-router'
import ServicesPage from '~/pages/ServicesPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Services | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'VICTORY digital printing machines, VisionJet inks & consumables, professional installation, and annual maintenance contracts — all from S.J.S. Technology.',
  },
  { property: 'og:title', content: 'Services | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/services' },
]

export default function Services() {
  return <ServicesPage />
}
